import * as React from "react";

import { Input, Button } from "antd";
import { toast } from "react-toastify";

class UserSettings extends React.Component<{}, {}> {
	public render() {
		return (
			<div className="container-fluid">
				<div className="form-group row">
					<div className="col-4">
						<label htmlFor="username">Username</label>
						<Input id="username" disabled={true} value="Username" />
					</div>
				</div>
				<div className="form-group row">
					<div className="col-4">
						<label htmlFor="name">Name</label>
						<Input id="name" value="Name" />
					</div>
				</div>
				<div className="form-group row">
					<div className="col-4">
						<label htmlFor="email">Email address</label>
						<Input id="email" value="name@example.com" />
					</div>
				</div>
				<div className="form-group">
					<Button type="primary" onClick={this.onSave}>
						Save
					</Button>
				</div>
			</div>
		);
	}

	private onSave = () => {
		toast.info("This feature is coming soon.");
	};
}
export default UserSettings;
